export const DEVICE_HEIGHT = window.innerHeight;
export const DEVICE_WIDTH = window.innerWidth;
